// page/2511 の <div class="opptrack"> をもとにしたもの。
//
// ★注文番号＋メールのフォームは持たない（2026-08-20 に廃止）。
//   注文番号が連番なので、メールアドレスが1つ分かれば総当たりで他人の注文を引けてしまう。
//   本人性は「メールを受け取った人だけが Guid を知っている」ことで担保する。
//   Guid が無い状態で開かれた場合は、メールのリンクとお問い合わせへ案内する。
//
// 原文は id で要素を引いていたが、同じページに複数のウィジェットが載ると衝突するので
// 全て class にして、ウィジェットのルート配下から querySelector で引く。
// 表示に関わる class 名（ot-*）と DOM の入れ子は原文のまま。

export const html = `
<div class="ot-head"><div class="ot-title">ご注文状況の確認</div></div>
<p class="ot-thanks-top">ご注文誠にありがとうございます。</p>
<p class="ot-lead js-lead">お客様のご注文状況を表示しています。</p>

<div class="ot-card">
  <div class="ot-loading js-loading">最新のご注文状況を照会しています…</div>

  <div class="ot-result js-result" aria-live="polite">
    <div class="ot-rhead js-rhead"></div>
    <div class="ot-meta">
      <div class="ot-ordno">注文番号 <b class="js-rorder"></b></div>
      <div class="ot-orddate js-rdate"></div>
    </div>
    <div class="ot-greet js-rname"></div>
    <div class="ot-pay js-rpay"></div>
    <div class="js-rsteps"></div>
    <div class="ot-refresh js-refresh-wrap" style="display:none">
      <button class="ot-btn js-refresh" type="button">最新の状況に更新する</button>
    </div>
    <div class="ot-updated js-rupdated"></div>
    <div class="ot-live js-live"></div>
  </div>

  <div class="ot-msg ot-err js-error"></div>
</div>

<div class="ot-guide">
  <h3>ご案内</h3>
  <ul>
    <li>この画面は開くたび・更新するたびに最新のご注文状況をリアルタイムで表示します（保存・キャッシュはしません）。</li>
    <li>銀行振込のご注文は、ご入金確認後の発送となります。</li>
    <li>ご注文確認メールに記載のリンクからお開きください。リンクがご不明な場合、お急ぎの場合は、お問い合わせフォームまたはお電話にてご連絡ください。</li>
  </ul>
</div>
`
